import React, { useState } from 'react';
import { Form, Input, Button, Card } from 'antd';
import { DatePicker } from 'Components';
import { postRequest } from 'api';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

interface Props {
    onSuccess?: () => void;
}

export const CreateClassYear: React.FC<Props> = ({ onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values: any) => {
        let { start, end, schoolYear } = values;
        setLoading(true);

        try {
            const schoolId = localStorage.getItem('schoolId');

            if (!schoolId) {
                toast.error('Không tìm thấy schoolId!');
                setLoading(false);
                return;
            }

            const startDate = start?.format?.("YYYY-MM-DD");
            const endDate = end?.format?.("YYYY-MM-DD");

            if (!startDate || !endDate) {
                toast.error('Vui lòng chọn đầy đủ ngày bắt đầu và kết thúc!');
                setLoading(false);
                return;
            }

            if (!schoolYear || schoolYear.trim() === '') {
                const startYear = start?.year?.(); // dayjs object
                const endYear = end?.year?.();
                schoolYear = `Năm học ${startYear}-${endYear}`;
            }

            const response = await postRequest(`/cms/class/${schoolId}/create-all-class-years`, {
                start: startDate,
                end: endDate,
                schoolYear,
            });

            if (response?.code === 200) {
                toast.success('Đã tạo năm học và nhân lớp thành công!');
                form.resetFields();
                onSuccess?.();
            } else {
                toast.error(response?.msg || 'Thêm năm học thất bại!');
            }
        } catch (error) {
            toast.error('Lỗi hệ thống khi thêm năm học!');
            console.error(error);
        }

        setLoading(false);
    };

    return (

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item label="Ngày bắt đầu" name="start" rules={[{ required: true }]}>
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
            </Form.Item>
            <Form.Item label="Ngày kết thúc" name="end" rules={[{ required: true }]}>
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
            </Form.Item>
            <Form.Item
                label="Tên năm học"
                name="schoolYear"
                rules={[{ message: 'Nhập tên năm học (VD: Năm học 2025-2026)' }]}
            >
                <Input placeholder="Nhập tên năm học" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Tạo năm học mới
                </Button>
            </Form.Item>
        </Form>

    );
};
